import { render, staticRenderFns } from "./gd-dlysjg-client-param-detail-modal.vue?vue&type=template&id=2089de0e"
import script from "./gd-dlysjg-client-param-detail-modal.vue?vue&type=script&lang=js"
export * from "./gd-dlysjg-client-param-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports